import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  IconButton,
  Button,
  Grid,
  Box,
} from "@mui/material";
import moment from "moment";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import RichTextEditor from "react-rte";
import Editor from "../../utils/common/Editor";
import EmailGenerate from "./EmailGenerate";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import EmailReplyEditorAI from "./EmailReplyEditorAI";
import { useParams } from "react-router-dom";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";
import { appLogger, Http } from "../../utils";
import _ from "lodash";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { apiChatUrl } from "../../utils/config";
import BasicDetails from "./BasicDetails";
import SystemInformation from "./SystemInformation";
import UserDetails from "./UserDetails";
import PageDetails from "./PageDetails";
import MediaAttachments from "./MediaAttachments";
import ContextDetails from "./ContextDetails";
import ChatDetails from "./ChatDetails";
import VideoAnalytics from "./VideoAnalytics";

const TicketDetails = (props: any) => {
  const { updateSubject, selectedPriority } = props;
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [expanded, setExpanded] = useState(false);
  const [showReplySection, setshowReplySection] = useState(false);
  const [loader, setLoader] = useState(false);
  const [mails, setMails] = useState<any>([]);
  const [feedbackDetails, setFeedbackDetails] = useState<any>();
  const { pagetype, ticketId } = useParams();

  useEffect(() => {
    fetchFeedbackDetails();
    fetchMails();
  }, []);
  const fetchMails = async () => {
    setLoader(true);
    try {
      const mailData: any = await Http.get({
        url: `/api/v2/mailing/${ticketId}`,
        state: userInfo,
      });
      appLogger.info({
        infoObj: {
          method: "fetchMails",
          component: "mailing",
          fileName: "mailingAnalyticsDrawer.tsx",
          mailData: mailData,
        },
      });
      if (mailData && mailData.length) {
        updateSubject(mailData[0].subject);
        // const combinedArray = combineObjects(mailData);
        // console.log(mailData, "mailData");
        mailData.sort(compareMailDates);
        setMails(mailData);
      } else {
      }
    } catch (error) {
      setLoader(false);
      props.snackbarShowMessage("Error in fetching new mails", "error");
      appLogger.error({
        infoObj: {
          method: "fetchMails",
          component: "mailing",
          fileName: "mailingAnalyticsDrawer.tsx",
          error: error,
        },
      });
    }
  };

  const fetchFeedbackDetails = async () => {
    // setLoader(true);
    try {
      const feedbackData: any = await Http.get({
        url: `/api/v2/userFeedback?id=${ticketId}`,
        state: userInfo,
      });
      appLogger.info({
        infoObj: {
          method: "fetchFeedbackDetails",
          component: "EmailReply",
          fileName: "EmailReply.tsx",
          feedbackData: feedbackData,
        },
      });
      if (feedbackData && feedbackData.Items && feedbackData.Items.length > 0) {
        setLoader(false);
        const data = feedbackData.Items[0];
        const userDetails: any = data.userDetails || "{}";
        const user =
          typeof userDetails === "string"
            ? JSON.parse(userDetails)
            : userDetails;
        if (user && Object.keys(user).length > 0) {
          if (user["uuid"]) {
            const bp = await getBPAnalyticsData(data.id, data.createdOn);
            data["bpAnalyticsDetails"] = bp;
          }
        }
        setFeedbackDetails(feedbackData.Items[0]);
      }
    } catch (error) {
      setLoader(false);
      props.snackbarShowMessage(
        "Error in fetching feedbackData in Email Reply",
        "error"
      );
      appLogger.info({
        infoObj: {
          method: "fetchFeedbackDetails",
          component: "EmailReply",
          fileName: "EmailReply.tsx",
          error: error,
        },
      });
    }
  };
  const getBPAnalyticsData = async (feedbackId: string, date: number) => {
    setLoader(true);
    appLogger.info(
      {
        infoObj: {
          method: "getBPAnalyticsData",
          component: "ticket-details-reply",
          fileName: "Ticketdetails.tsx",
        },
      },
      "BP Analytics Data"
    );
    let analyticsData: any = [];
    const hours: any = 120; //5days
    try {
      analyticsData = await Http.get({
        url: `/api/v2/bpanalytics/${feedbackId}/${date}/${hours}`,
        state: userInfo,
      });
      setLoader(false);
      appLogger.info(
        {
          infoObj: {
            method: "getBPAnalyticsData",
            component: "feedback",
            fileName: "reports.tsx",
            analyticsData: analyticsData,
          },
        },
        "BP analytics Data"
      );
      return analyticsData["data"];
    } catch (err) {}
    return analyticsData;
  };

  // Function to combine objects based on messageId
  const combineObjects = (mails: any) => {
    const combined: any = {};
    mails.forEach((obj: any) => {
      const { messageId } = obj;
      if (!combined[messageId]) {
        combined[messageId] = { ...obj };
      } else {
        Object.assign(combined[messageId], obj);
      }
    });
    return Object.values(combined);
  };

  const compareMailDates = (a: any, b: any) => {
    return a.createdOn > b.createdOn ? 1 : -1;
  };
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  const handleSendReply = () => {
    setshowReplySection(!showReplySection);
  };
  const onDelete = () => {
    setshowReplySection(!showReplySection);
  };
  const forwardIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.28009 0.969592C4.4207 1.11024 4.49968 1.30097 4.49968 1.49984C4.49968 1.69871 4.4207 1.88944 4.28009 2.03009L2.56034 3.74984H6.74985C8.14223 3.74984 9.4776 4.30297 10.4621 5.28753C11.4467 6.27207 11.9999 7.60744 11.9999 8.99982V10.4998C11.9999 10.6987 11.9208 10.8895 11.7802 11.0301C11.6396 11.1708 11.4488 11.2498 11.2499 11.2498C11.051 11.2498 10.8602 11.1708 10.7195 11.0301C10.5788 10.8895 10.4999 10.6987 10.4999 10.4998V8.99982C10.4999 8.00524 10.1048 7.05147 9.40148 6.3482C8.6982 5.64493 7.74443 5.24984 6.74985 5.24984H2.56034L4.28009 6.96957C4.35173 7.03879 4.40886 7.12152 4.44817 7.21302C4.48748 7.30452 4.50816 7.40299 4.50903 7.50252C4.50989 7.60212 4.49092 7.70089 4.45321 7.79307C4.4155 7.88524 4.3598 7.96895 4.28939 8.03937C4.21897 8.1098 4.13523 8.16552 4.04306 8.20324C3.95088 8.24089 3.85212 8.25987 3.75254 8.25904C3.65296 8.25814 3.55454 8.23744 3.46304 8.19814C3.37154 8.15884 3.28877 8.10169 3.21959 8.03007L0.219592 5.03009C0.07899 4.88944 0 4.69871 0 4.49984C0 4.30097 0.07899 4.11024 0.219592 3.96959L3.21959 0.969592C3.36023 0.82899 3.55097 0.75 3.74984 0.75C3.94871 0.75 4.13945 0.82899 4.28009 0.969592Z"
          fill="#0157ff"
        />
      </svg>
    );
  };
  const handleOnChange = (value: any) => {
    // setEditorData(value);
  };
  const updateEmailList = () => {
    fetchMails();
    setshowReplySection(!showReplySection);
  };
  const getFirstAndLastLetters = (str: any) => {
    return str[0].toUpperCase() + "" + str[str.length - 1].toUpperCase();
  };

  return (
    <Grid sx={{ display: "flex" }} className={loader ? "loader" : ""}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} sx={{ position: "relative" }}>
          <BasicDetails
            pageType={pagetype}
            detailRow={feedbackDetails}
            selectedPriority={selectedPriority}
          />
          <SystemInformation pageType={pagetype} detailRow={feedbackDetails} />
          <UserDetails pageType={pagetype} detailRow={feedbackDetails} />
          <PageDetails pageType={pagetype} detailRow={feedbackDetails} />
          <ContextDetails pageType={pagetype} detailRow={feedbackDetails} />
          <MediaAttachments pageType={pagetype} detailRow={feedbackDetails} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ChatDetails pageType={pagetype} detailRow={feedbackDetails} />
          <VideoAnalytics pageType={pagetype} detailRow={feedbackDetails} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withSnackbar(TicketDetails);
